import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService } from 'src/app/auth/auth.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { State } from 'src/app/store/state';
import { ERToolService} from '../services/er-tool.service';
import { MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { HttpErrorResponse } from '@angular/common/http';
import * as constants from 'src/app/config/app-constants';
import { Profile } from 'src/app/shared/models/auth/profile';
import {ErListComponent} from '../components/er-list/er-list.component';

@Component({
    selector: 'app-er-tool',
    templateUrl: './er-tool.component.html',
    styleUrl: './er-tool.component.scss',
    standalone: false
})
export class ERToolComponent implements OnInit{

 profile: Profile; 
 error: HttpErrorResponse;
 isShowErt : boolean = true;

 constructor(
     public auth: AuthService,
     public toastService: ToastService,
     public dialog: MatDialog,

     ) {  
   }


  ngOnInit(): void {


     this.auth.profile$.subscribe(profile => {
     this.profile = profile; 
            
    });

    

  }


}
